import { Injectable,  } from '@angular/core';
import { EnvironmentKeys } from 'src/environments/environment-keys';
import { ConfigService } from './json-config.service';
import { LoggerService } from './logger/logger.service';
import { PosthogService } from './posthog.service';
import { RestApiService } from './rest-api/rest-api.service';
import { UserService } from './user/user.service';
import { UserTypes } from './rest-api/rest-api';
import { ToastNotificationService } from './toast-notification/toast-notification.service';
import { ToastNotificationComponent } from '../shared/toast-notification/toast-notification.component';
import { parseToError } from '../shared/functions-angular';

interface LogoutInput {
  idToken?: string,
  displayErrorOnRedirectBack?: UserTypes
  idleLogoutMessage?: boolean
}

interface LogoutOptions {
  withMessage?: 'idleLogoutMessage',
  userType?: UserTypes,
}

@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  private _localAppUrl = '';

  public get localAppUrl(): string {
    const origin = window?.location?.origin;
    if(origin) {
      this._localAppUrl = origin + '/login';
    }

    return this._localAppUrl;
  }

  public constructor(
    private userService: UserService,
    private restApiService: RestApiService,
    private configService: ConfigService,
    private posthogService: PosthogService,
    private loggerService: LoggerService,
    private toastService: ToastNotificationService,
  ) {}

  public logOut(options?: LogoutOptions): void {
    this.restApiService.logoutBackend().subscribe({
      next: (data) => {
        this.finishLogout({
          idleLogoutMessage: !!options?.withMessage,
          ...data,
        });
      },
      error: (error: unknown) => {
        const parsedError = parseToError(error);

        if(parsedError && parsedError.status !== 401 && parsedError.status !== 403) {
          this.loggerService.error('Error during logout process: ', error);
        }
        this.finishLogout({idleLogoutMessage: !!options?.withMessage});
      },
    });
  }

  public finishLogout(options?: LogoutInput): void {
    this.userService.removeUserFromLocal()
    this.posthogService.endLog();

    // consult logout keycloak feature does not exist so just redirect user to desired variable url
    const consultRedirectUrl = this.configService.getConfig(EnvironmentKeys.collabAfterLogoutRedirectUrl);
    if(options?.idleLogoutMessage) {
      this.toastService.addNotification({
        title: 'toastNotifications.headers.idleLogout',
        message: 'toastNotifications.messages.idleLogout',
        type: 'warning',
        component: ToastNotificationComponent
      });
    }
    if(consultRedirectUrl) {
      window.location.href = consultRedirectUrl;
      return;
    }
  }
}
